import React from 'react';
import { reportError } from 'ha/helpers/bugsnag/reportError';
import { LoadableSomethingWentWrong } from './SomethingWentWrong';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<Props, State> {
  state = {
    hasError: false,
  };

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.setState({ hasError: true });
    reportError(error, { metaData: info });
  }

  render() {
    if (this.state.hasError) {
      return <LoadableSomethingWentWrong />;
    }

    return this.props.children;
  }
}
